import auth from '../utils/auth'

const tokenRequestTdm = {
  scopes: ['api://3243f2bc-0c86-4a68-80c4-6f041c855ffa/User.ReadWrite'],
  forceRefresh: false
}

const tokenRequestPda = {
  scopes: ['api://ef6616de-65f3-46e9-9b89-f0a602145214/User.ReadWrite'],
  forceRefresh: false
}

export class TdmWebApi {

  static async getSyncSettings() {
    const url = process.env.VUE_APP_TDM_API_URL + "/SyncSettings";
    const options = await auth.getOptions(tokenRequestTdm, 'GET');
    return await Shared.callFetch(url, options);
  }

  static async postSyncSettings(syncSettings) {
    const url = process.env.VUE_APP_TDM_API_URL + "/SyncSettings";
    const options = await auth.getOptions(tokenRequestTdm, 'POST', JSON.stringify(syncSettings), true);
    return await Shared.callFetch(url, options);
  }

  static async getSyncQueueStatus() {
    const url = process.env.VUE_APP_TDM_API_URL + "/SyncQueue/Status";
    const options = await auth.getOptions(tokenRequestTdm, 'GET');
      return await Shared.callFetch(url, options);
  }

  static async postSyncQueueCommand(cmd) {
    const url = process.env.VUE_APP_TDM_API_URL + `/SyncQueue/${cmd}`;
    const options = await auth.getOptions(tokenRequestTdm, 'POST');
    return await Shared.callFetch(url, options);
  }

  static async getTabletList() {
    const url = process.env.VUE_APP_TDM_API_URL + "/TabletList";
    const options = await auth.getOptions(tokenRequestTdm, 'GET');
    return await Shared.callFetch(url, options);
  }

  static async getSyncTabletInfo() {
    const url = process.env.VUE_APP_TDM_API_URL + "/SyncTablet";
    const options = await auth.getOptions(tokenRequestTdm, 'GET');
    return await Shared.callFetch(url, options);
  }

  static async deleteSyncTablet(name) {
    const url = process.env.VUE_APP_TDM_API_URL + `/SyncTablet?Name=${name}`;
    const options = await auth.getOptions(tokenRequestTdm, 'DELETE');
      return await Shared.callFetch(url, options);
  }

  static async postSyncTablet(tablet) {
    const url = process.env.VUE_APP_TDM_API_URL + "/SyncTablet";
    const options = await auth.getOptions(tokenRequestTdm, 'POST', JSON.stringify(tablet), true);
    return await Shared.callFetch(url, options);
  }

  static async getSyncScheduleList() {
    const url = process.env.VUE_APP_TDM_API_URL + "/SyncSchedule";
    const options = await auth.getOptions(tokenRequestTdm, 'GET');
    return await Shared.callFetch(url, options);
  }

  static async deleteSyncScheduleItem(id, name) {
    const url = process.env.VUE_APP_TDM_API_URL + `/SyncSchedule?Id=${id}&Name=${name}`;
    const options = await auth.getOptions(tokenRequestTdm, 'DELETE');
    return await Shared.callFetch(url, options);
  }

  static async postSyncSchedule(sched) {
    const url = process.env.VUE_APP_TDM_API_URL + "/SyncSchedule";
    const options = await auth.getOptions(tokenRequestTdm, 'POST', JSON.stringify(sched), true);
    return await Shared.callFetch(url, options);
  }

  static async postQueueSync(syncRequest){
    const url = process.env.VUE_APP_TDM_API_URL + "/SyncQueue/QueueSync";
    const options = await auth.getOptions(tokenRequestTdm, 'POST', JSON.stringify(syncRequest), true);
    return await Shared.callFetch(url, options);
  }
}

export class PdaWebApi {
  static async getPdaPedigreeFarms() {
    const url = process.env.VUE_APP_PDA_API_URL + "/farms";
    const options = await auth.getOptions(tokenRequestPda, 'GET');
    return await Shared.callFetch(url, options);
  }
}

export class SeqLogApi {
  static async readLog(startUTC, endUTC, maxItems) {
    maxItems++; // off by 1 for some reason.
    //* Note: for further parameter options see: http://cvipda-apps:5341/api/events/resources
    let  url = "https://cvipda-apps.cobb-vantress.com:5443/api/events?"
              + "signal=signal-333,"  // PTAP
              + (process.env.VUE_APP_MODE === "production" ? "signal-19" : "signal-16") //  PROD or TEST/DEV
              + `&count=${maxItems}&fromDateUTC=${startUTC}`;
    if (endUTC != null) url += `&toDateUTC=${endUTC}`;
    return await Shared.callFetch(url, { method: "GET" });
  }
}

class Shared {
  static async callFetch(url, fetchData) {
    let response = await fetch(url, fetchData);

    if (response.ok) {
      var text = await response.text();
      if (text.length == 0) return null;
      const data = JSON.parse(text);
      return data;
    }

    let error = null;
    try {
      error = await response.json();
    }
    
    // eslint-disable-next-line no-empty
    catch {}

    if (error) throw `${error.title} [${response.status}]: ${error.message}`;
    else throw "Response Status: " + response.status;
  }
}

export default TdmWebApi;
